import React from "react"
import { useQuery, gql } from "@apollo/client"

interface Status {
  id: number
  name: string
  status: string
  date: Date
}
interface StatusData {
  statusUpdate: Status
}

const StatusQuery = gql`
  {
    statusUpdate(id: 150) {
      id
      name
      status
      date
    }
  }
`

const PlanStatusQuery = (): JSX.Element => {
  const { loading, error, data } = useQuery<StatusData, Status>(StatusQuery)
  return (
    <div>
      {loading ? (
        "loading..."
      ) : (
        <p>
          Status {data.statusUpdate.id} updated by {data.statusUpdate.name} and
          status is now {data.statusUpdate.status}
        </p>
      )}
    </div>
  )
}
export default PlanStatusQuery
